import { BaseEntity } from "yt-ng-framework";

export class BracniStatus extends BaseEntity{
    constructor(){
        super();
    }
    
Naziv: string=null;
datetimecr: Date;

Deserialize(input: any){
    this.ID = input.ID;
    this.Naziv = input.Naziv;
        
    return this;
}

Serialize(input: BracniStatus){
    return input;
}
}

